<template>
  <BaseEmptyState class="empty-state-icon-alt w-full my-base bg-whiteOverride">
    <template v-slot:icon>
      <div>
        <TeamsIcon/>
      </div>
    </template>
    <template v-slot:title>
      <h2 class="text-center">{{ $t('ui.teams.emptyState.noTeams.title') }}</h2>
    </template>
    <template v-slot:content>
      <p class="text-center">{{ $t('ui.teams.emptyState.noTeams.info') }}</p>
      <BaseButton
        class="flex mx-auto"
        data-test="teams-button-text"
      >
      {{ $t('ui.teams.emptyState.noTeams.cta') }}
      </BaseButton>
    </template>
  </BaseEmptyState>
</template>

<script>
import BaseEmptyState from '@/components/library/emptyStates/BaseEmptyState.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import { TeamsIcon } from '@/components/icons/svgIcons/TeamsIcon';

export default {
  name: 'TeamsEmptyState',
  components: {
    BaseEmptyState,
    BaseButton,
    TeamsIcon,
  },
};
</script>

<style scoped>
.empty-state-icon svg {
  @apply h-eightyEight w-eightyEight;
}
.empty-state-content h2 {
  @apply max-w-xl;
}
.empty-state-content p {
  @apply text-16 max-w-xl;
}
</style>
